exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-content[data-v-4195db39]{position:fixed;z-index:999;box-sizing:border-box;width:350px;min-height:20px;padding:20px;font-size:15px;font-size:14px;text-align:center;background:#fff;border-radius:3px;box-shadow:0 2px 12px rgba(0,0,0,.15)}.progress-content .top-progress .top-progress-content[data-v-4195db39]{margin-bottom:10px;color:#4d5365}", ""]);

// exports
